import {TListResponse} from '../types';
import instance from './instance';

export interface TReview {
  id: number;
  subject: 'model';
  subject_id: string;
  name: string;
  rating: 1 | 2 | 3 | 4 | 5;
  comment: string;
  created_at: string;
  images: [];
  object: {
    _id: string;
    name: string;
    phone_number: string[];
    profile_url: string;
    address: string;
    thumb: string;
    status: 'active';
  };
}

type ReviewResponse = TListResponse<TReview> & {
  limit: number;
  offset: number;
};

export const fetchMyReviews = () => instance.get<ReviewResponse>('/frontend/api/v1/reviews');

export const deleteReview = (reviewId: string) =>
  instance.delete(`/frontend/api/v1/reviews/${reviewId}`);
